import { BasicCommand } from "./BasicCommand";
/**
 * Created by tschenkel on 1/6/2015.
 */


import { BasicController } from "../BasicController";
import { BasicSmartfoxConstants } from "../BasicSmartfoxConstants";
import { SetInviteCodeEvent } from "../../event/SetInviteCodeEvent";
import {CoreErrorIdConstants} from "@goodgamestudios/shared-constants";

/**
 * Command used to set a invite code.
 *
 * Documentation see here:
 * https://sites.google.com/a/goodgamestudios.com/tech-wiki/java/gamedocumentation/core/events/setinvitecodeevent
 */
export class SICCommand extends BasicCommand {
    protected get cmdId(): string {
        return BasicSmartfoxConstants.S2C_SET_INVITE_CODE;
    }

    public executeCommand(error: number, params: any[]): boolean {
        let success: boolean = false;

        switch (error) {
            case CoreErrorIdConstants.OK:
                success = true;

                BasicController.getInstance().dispatchEvent(new SetInviteCodeEvent(SetInviteCodeEvent.INVITE_CODE_SET, error));
                break;

            case CoreErrorIdConstants.LOGIN_PLAYER_IS_BANNED:
            case CoreErrorIdConstants.FEATURE_NOT_AVAILABLE:
            case CoreErrorIdConstants.INVALID_PARAMETER_VALUE:
            case CoreErrorIdConstants.GENERAL_ERROR:
            case CoreErrorIdConstants.FRIENDINVITE_WRONG_ZONE_ERROR:
            case CoreErrorIdConstants.FRIENDINVITE_UNKNOWN_INVITER_ERROR:
            case CoreErrorIdConstants.FRIENDINVITE_INVITEE_LIMIT_REACHED_ERROR:
            case CoreErrorIdConstants.FRIENDINVITE_RELATION_ALREADY_EXISTS_ERROR:
            case CoreErrorIdConstants.FRIENDINVITE_REGISTRATION_BEFORE_INVITECODE_CREATION_ERROR:
            case CoreErrorIdConstants.FRIENDINVITE_INVALID_CODE_ERROR:
            case CoreErrorIdConstants.FRIENDINVITE_FEATURE_IS_BLOCKED_FOR_INVITER_ERROR:
            case CoreErrorIdConstants.FRIENDINVITE_CANNOT_INVITE_SELF_ERROR:
                BasicController.getInstance().dispatchEvent(new SetInviteCodeEvent(SetInviteCodeEvent.SET_INVITE_CODE_FAILED, error));
                break;
        }
        return success;
    }
}

